module.exports = __webpack_public_path__ + "img/bell.808ca187.svg";